/* eslint-disable react/react-in-jsx-scope */
import { useEffect } from "react";

import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useFetchData } from "@/hooks/useFetchData";
import { returnedData, saveData } from "@/store/useDataStore";
import { useState } from "react";

const Photo = ({ project: projectInit, guide }) => {
  const [loading, setLoading] = useState(false);
  // project = JSON.parse(localStorage.getItem("project"));
  const [project, setProject] = useState(null);
  useEffect(() => {
    (async () => {
      setProject(await returnedData("project"));
    })();
  }, []);

  const [attachments, setAttachments] = useState([]);

  const fetchConstraints = useFetchData(
    `${import.meta.env.VITE_IP_API}/media/constraints`
  );

  useEffect(() => {
    setAttachments(project?.mediaPhotos);
  }, [project]);

  useEffect(() => {
    if (project) {
      saveData(
        "project",
        JSON.stringify({
          ...project,
          mediaPhotos: attachments,
        })
      );
    }
  }, [attachments]);

  if (fetchConstraints.loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {guide && <h2 className="mb-2 mt-4 text-xl font-bold">Photos : </h2>}

      <div className="relative space-y-2">
        {guide && (
          <p className="mb-4 text-sm">
            Ajoutez toutes les photos relatives au projet.
          </p>
        )}
      </div>
    </>
  );
};

export default Photo;
